<template>
  <div>

    <v-navigation-drawer  dark temporary :right="right" v-model="guestLeftDrawer" app
                         class="primary guest-nav-menu" style="z-index: 999;">

<!--      <v-toolbar color="primary lighten-1" >-->
        <v-flex class="gutter-mobile-header primary" />

        <v-list dark class="primary  v-toolbar" >
          <v-list-tile avatar>


            <v-list-tile-avatar  >
              <v-img src="static/images/avatar180x.jpg"></v-img>
            </v-list-tile-avatar>

            <v-list-tile-content >
              <v-list-tile-title>Guest User</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn color="white" outline @click.native="guestLeftDrawer=!guestLeftDrawer"
                     v-if="$route.path !== '/login' && !isAuth && $store.state.device.isMobile === false"
                     to="/login">Sign in</v-btn>
              <v-btn color="white" outline  @click.native="guestLeftDrawer=!guestLeftDrawer"
                     v-if="$route.path === '/login' && $store.state.device.isMobile === false"
                     to="/signup">Sign up</v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

<!--      </v-toolbar>-->

      <v-list class="pt-0 primary darken-1" dense>
        <v-list-tile>
          <v-list-tile-action >
            <v-icon>schedule</v-icon>
          </v-list-tile-action>

          <v-list-tile-content >
            <v-list-tile-title>

              <span v-text="humanTime" class="mr-1 font-weight-bold yellow--text subheading"/><span class="font-weight-bold">Hrs</span> of Activity</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <div v-for="(item, index) in items"
             :key="item.title">

        <v-list-group
          v-if="typeof item.items !== 'undefined' && item.isActive === true && item.isActive === true"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list-group>

          <v-list-tile
            v-if="item.routeName &&
            typeof item.items === 'undefined' &&
            item.isActive === true"
            :key="item.title" :class="item.routeName === $route.name ? 'selectedRoute' :'' "
            @click="openRoute(item.routeName)"
          >

            <v-list-tile-content >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-else-if="item.divider" :key="index"></v-divider>
          <v-subheader v-else-if="item.header" :key="item.header" class="grey--text text--lighten-4">
            {{ item.header}}
          </v-subheader>
        </div>
      </v-list>
      <v-spacer></v-spacer>
    </v-navigation-drawer>
  </div>
</template>

<script>

function secondsToTime (e) {
  const h = Math.floor(e / 3600).toString().padStart(2, '0')
  const m = Math.floor(e % 3600 / 60).toString().padStart(2, '0')
  const s = Math.floor(e % 60).toString().padStart(2, '0')
  return `${h}:${m}:${s}`
}

export default {
  name: 'GuestLeftNavigationMenu',
  components: {
  },
  data () {
    return {
      humanTime: 0,
      totalSeconds: 0,
      right: true,
      hasAvatar: true,
      items: [
        {
          routeName: 'Home',
          title: 'Home',
          isActive: true
        },
        { divider: true },
        {
          routeName: 'CertificateProgram',
          title: 'Certificate program',
          isActive: true
        },
        { divider: true },
        // {
        //   routeName: 'Faq',
        //   title: 'Frequently asked questions',
        //   isActive: true
        // },
        // { divider: true },
        {
          routeName: 'PrivacyPolicy',
          title: 'Privacy policy',
          isActive: true
        },
        { divider: true },
        {
          routeName: 'TermsOfUse',
          title: 'Terms of use',
          isActive: true
        },
        { divider: true },
        {
          routeName: 'AnsiAccreditation',
          title: 'ANSI Accreditation',
          isActive: true
        },
        { divider: true }
      ]
    }
  },
  mounted () {
    // setInterval(() => {
    //   this.totalSeconds += 1
    //   this.updateTime()
    // }, 1000)
  },
  computed: {
    guestLeftDrawer: {
      get: function () {
        return this.$store.getters.guestLeftDrawer
      },
      set: function (value) {
        this.$store.commit('toggleGuestLeftDrawer', value)
      }
    },
    isAuth () {
      return this.$auth.check()
    }
  },
  methods: {
    openRoute (route) {
      this.guestLeftDrawer = false
      this.$router.push({name: route})
    },
    updateTime () {
      // this.$store.commit('user/setTimer', {total: this.totalSeconds + 1})
      this.humanTime = secondsToTime(this.totalSeconds)
    }
  }
}
</script>
<style scoped lang="stylus">
  .selectedRoute {
    background : rgba(255,255,255,0.12)
    cursor: default
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/GuestLeftNavigationMenu.vue